import _ from 'lodash';
import { dataProvider } from '../../../firebase';
import { ISpeaker } from '../../../types';
import { ISpk, ParserAlgo } from './types';

export type TParserAlgo =
  | typeof ParserAlgo.lastName
  | typeof ParserAlgo.LASTNAME
  | typeof ParserAlgo.nameLastn
  | typeof ParserAlgo.namesLastn;

function trimChar(st: string, charToRemove: string) {
  while (st.charAt(0) == charToRemove) {
    st = st.substring(1);
  }

  while (st.charAt(st.length - 1) == charToRemove) {
    st = st.substring(0, st.length - 1);
  }

  return st;
}

const curateName = (nm: string) => trimChar(nm, '.');

export function getSpeakersFromInputText(
  speakersRaw: string,
  algo: TParserAlgo,
  lineSep: string,
  removeWords: string[],
  nmSep: string,
): ISpk[] {
  /* tslint:disable-next-line prefer-template*/
  let speakersArr = speakersRaw.split(new RegExp('[\r\n]+|' + lineSep));
  speakersArr = _.map(speakersArr, spkLine => {
    let spkCured = spkLine;
    _.each(removeWords, function (r) {
      const re = new RegExp(r, 'g');
      spkCured = spkCured.replaceAll(re, '');
    });
    spkCured = spkCured.replaceAll(/\s+/g, ' '); // compact whitespaces
    spkCured = spkCured.trim(); // remove whitespaces at end/begining
    return spkCured;
  });
  speakersArr = _.compact(speakersArr); // remove empty lines

  let res: ISpk[] = _.map(speakersArr, function (spk) {
    // let nmSep = ' ';
    // if (spk.includes('@')) {
    //   nmSep = '@';
    // }
    let nm: string[];
    let lastName: string;
    let name: string;
    // console.log('Algo=', algo);
    switch (algo) {
      case ParserAlgo.lastName:
        // console.log('Using lastnName algorithm');
        nm = spk.includes(nmSep) ? spk.split(nmSep) : spk.split(' ');
        lastName = _.first(nm)!;
        name = _.tail(nm).join(' ');
        break;

      case ParserAlgo.LASTNAME:
        // console.log('Using LASTNAME algorithm');
        const lastNameArr = /([^a-z]{2,})/.exec(spk);
        lastName = lastNameArr ? lastNameArr[1] : '';
        const nameArr = /([^A-Z]{2,})/.exec(spk);
        name = nameArr ? nameArr[1] : '';
        break;

      case ParserAlgo.namesLastn:
        // console.log('Using nameSLastn 1 algorithm');
        nm = spk.includes(nmSep) ? spk.split(nmSep) : spk.split(' ');
        name = _.initial(nm).join(' ');
        lastName = _.last(nm)!;
        break;

      case ParserAlgo.nameLastn:
        // console.log('Using nameLastn algorithm');
        nm = spk.includes(nmSep) ? spk.split(nmSep) : spk.split(' ');
        name = _.first(nm)!;
        lastName = _.tail(nm).join(' ');
        break;

      default:
        alert('Algo desconocido');
        console.error(`Algo desconocido '${algo}' `);
        lastName = name = 'cargaErronea';
    }
    return { lastName: lastName.trim(), name: name.trim() };
  });
  res = res.map((sp: ISpk) => ({ name: curateName(sp.name), lastName: curateName(sp.lastName) }));
  res = _.uniqWith(res, (sp1, sp2) => sp1.name === sp2.name && sp1.lastName === sp2.lastName); // remove duplicates
  // console.log({ speakers: res });
  return res;
}

export const getOrCreateSpeaker = async (
  allSpkrs: ISpeaker[] | undefined,
  name: string,
  lastName: string,
  countryId?: string,
): Promise<string> => {
  const spk = allSpkrs?.find((sp: ISpeaker) => sp.firstname === name && sp.lastname === lastName);
  if (spk) {
    // console.log('Returning existitng spk ', { spk });
    return spk.id;
  }
  const speaker: Omit<ISpeaker, 'id' | 'countryId'> = {
    ...(countryId && { countryId }),
    firstname: name,
    lastname: lastName,
    isRockStar: false,
    cv: '',
    avatar: undefined,
  };

  const newSpk = await dataProvider.create<ISpeaker>('speakers', { data: speaker });
  // console.log('Returning new spk ', { newSpk });
  return newSpk?.data?.id || '';
};
